export default __webpack_public_path__ + "static/media/edit.26a322da.svg";